var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1788_104069",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1788_104069",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAACDUlEQVRoge2Xz0sUYRyHn+867o4KBh2MFjoI/cSKPERl/QWBh41O/g8G0q+FRdukSDzkQf+FblFeQuoSEXTyoiX9WIhgg7xooUEOu87bwUu8M7Pjjs5MA+9z/L7v553Pw8K7M2AwGDKN+E7HVg5SYAJUCSgCq4h6DtZ9Hp1aS7RhCF6BnfLvQJ3w2f8Fu3GB6uCv+KvtjpxnklfjAeUBjvMnX4m3Unt4BYRrrROqFFeZKHgF4HDLhOJIPFWi4SewGpL5EUeRqPgIyLPWEfU0nirR8Ao4TAK1gP0fsZsPYm3UJl6BmYF1Gp1DwBzwHWgC31A8Bvfy/3SFGgz7gPdVovxBhaamTu89d+dTkY7GCIphkH6gD1gDvqLkBZb7hIdn6mFHWqEP3W9GawV6nAo0yyjp1FaLQBFRV9iWe5RXZrG7J6j2bwUd5/dHFh93Fw/Q47wFxgG9vI4N6jZbv19za6kvaFOyAtK1AJxvM3QRy5pntFbwW01WAHUpcq7bmfRbSVhgDwg3qLz3vEhmRwBstmVEH6YhUAeu41q9uFYvkiuBfN5dVF3VJ0lfo3UcOcfMwPo/s3nKy28gtwRh3xpyVJ8k/QuMaeV3mDr7E+RmeFwO6ZNkBVzrVeCanX8ZfoDq0CfJCkyf3Axcqx7biHJklm4hX4xA2hiBtDECaWME0sYIpI0RSJvMCxgMhozzF6yLcwBDfZPMAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinShare);
export default __webpack_public_path__ + "static/media/linkedin_share.d58ce507e07c248ef7b08023a99b02ec.svg";
export { ForwardRef as ReactComponent };